__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "it_incubator_personal_page_respect_front";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@it-incubator/ui-kit", "1.0.8", () => (Promise.all([__webpack_require__.e(361), __webpack_require__.e(209), __webpack_require__.e(58), __webpack_require__.e(325), __webpack_require__.e(940), __webpack_require__.e(26)]).then(() => (() => (__webpack_require__(2361))))));
			register("@tanstack/react-query", "5.8.1", () => (Promise.all([__webpack_require__.e(657), __webpack_require__.e(58), __webpack_require__.e(505)]).then(() => (() => (__webpack_require__(6657))))));
			register("axios", "1.6.1", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(832)]).then(() => (() => (__webpack_require__(3513))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(241), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(9241))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(741), __webpack_require__.e(209), __webpack_require__.e(298)]).then(() => (() => (__webpack_require__(741))))));
			register("react-router-dom", "6.18.0", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(253)]).then(() => (() => (__webpack_require__(2117))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(506), __webpack_require__.e(515), __webpack_require__.e(886)]).then(() => (() => (__webpack_require__(5506))))));
			register("react", "18.2.0", () => (__webpack_require__.e(944).then(() => (() => (__webpack_require__(8944))))));
			initExternal(8524);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};